import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Aux from '../hoc/Aux';
import useCustomHtmlTranslation from '../hooks/useCustomHtmlTranslation';
import { ROUTES } from '../routes';
import magicadLogo from '../images/magicad-logo.png';
import revitLogo from '../images/revit-logo.png';

const revitPlugin = (props) => {
  const ht = useCustomHtmlTranslation();
  const { t } = useTranslation();

  // Die Seite ist in beiden Zweigen der Navigation verlinkt, also auch fuer
  // angemeldete Nutzer erreichbar. Denen einen Login-Knopf hinzustellen waere
  // sinnlos, deshalb haengt er an derselben Bedingung wie in App.js.
  const isAuthenticated = useSelector(state => state.auth.token !== null);

  return (
  <Aux>
    <div className="main-container">
       <div className="container">
          <div className="row justify-content-center">
             <div className="col-lg-11 col-xl-10">
               <h1>{ ht('content.revit_plugin.headline') }</h1><br />

               <div className="d-flex align-items-center flex-wrap mb-4">
                 <img src={magicadLogo} alt="Powered by MagiCAD Cloud" style={{height: '48px', marginRight: '32px'}} />
                 <img src={revitLogo} alt="Revit" style={{height: '48px'}} />
               </div>

               { ht('content.revit_plugin') }

               { ( !isAuthenticated ) &&
                 <p className="mt-4">
                   <Link to={ROUTES.TO_LOGIN} className="btn btn-primary btn-project">
                     { t('navigation.link.login') }
                   </Link>
                 </p>
               }
             </div>
          </div>
       </div>
    </div>
  </Aux>
  )
};

export default revitPlugin;



// WEBPACK FOOTER //
// ./src/components/RevitPlugin.js